import styled from 'styled-components';

import {
  grey1,
  grey4,
  purple1,
  purple7,
} from 'approot/shared/styles/colours.style';
import {
  spacing4,
  spacing8,
  spacing16,
} from 'approot/shared/styles/spacing.style';
import { rem } from 'approot/shared/style';
import {
  baseFlexCss,
  flexCentreAlignCss,
} from 'approot/shared/styles/flex.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import {
  borderRadius16,
  boxShadowBlack12,
} from 'approot/shared/styles/borders.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { HrStyled } from 'approot/shared/styles/decorative.style';
import { DRAW_TOOLBAR_Z_INDEX } from '../draw-canvas.constants';

export const ToolbarContainer = styled(Box).attrs({
  $flexDirection: 'column',
  $alignItems: 'center',
  $justifyContent: 'center',
})`
  top: ${rem(120)};

  @media (max-height: 768px) {
    top: ${rem(100)};
    padding-top: ${rem(150)};
    padding-bottom: ${rem(100)};
    justify-content: flex-start;
  }

  position: fixed;
  width: 100px;
  overflow: auto;
  height: 100%;
  bottom: 0;
  right: ${rem(spacing16)};
  z-index: ${DRAW_TOOLBAR_Z_INDEX};
`;

export const Toolbar = styled.div`
  border-radius: ${rem(borderRadius16)};
  padding: ${rem(spacing8)};
  gap: ${rem(spacing8)};
`;

export const ToolbarCore = styled(Box).attrs({
  $gap: 12,
  $alignItems: 'center',
  $flexDirection: 'column',
})`
  position: relative;
`;

export const ToolbarItems = styled.ul`
  ${baseFlexCss}
  ${boxShadowBlack12}
  background-color: ${grey1};
  border: 1px solid ${grey4};
  border-radius: ${rem(40)};
  flex-direction: column;
  gap: ${rem(spacing4)};
  margin: 0;
  padding: ${rem(spacing4)};
`;

export const ToolbarItem = styled.li`
  list-style: none;
  position: relative;
`;

type ToolBarToolProps = {
  $isActive?: boolean;
};
export const ToolBarTool = styled(SecondaryButtonIcon).attrs({
  type: 'button',
  $borderRadius: 40,
})<ToolBarToolProps>`
  border: 1px solid ${grey1};
  ${flexCentreAlignCss}

  &:hover {
    background-color: ${purple1};
  }

  ${({ $isActive }) =>
    $isActive &&
    `
      border: 1px solid ${purple7};
  `}
`;

export const ToolbarContextualMenu = styled(Box).attrs({
  $gap: spacing8,
  $alignItems: 'center',
  $flexDirection: 'column',
})`
  position: absolute;
  bottom: 101%;
  left: 0;
`;

export const ToolbarContextualMenuItem = styled.div`
  position: absolute;
  left: 0;
  top: 0;
`;

export const ToolbarMenuDivider = styled(HrStyled).attrs({
  $marginBottom: spacing4,
  $marginTop: spacing4,
})`
  width: 100%;
`;
